import Vue from "vue";

import FullLayoutComponent from "@/components/layouts/FullLayout.vue";
import LeftMenuLayoutComponent from "@/components/layouts/LeftMenuLayout.vue";
import DateClockComponent from "@/components/shared/DateClock.vue";
import BreadcrumbComponent from "@/components/shared/Breadcrumb.vue";
import UserBadgeComponent from "@/components/badges/UserBadge.vue";
import FeedbackBadgeComponent from "@/components/badges/FeedbackBadge.vue";
import FeedbackAverageBadgeComponent from "@/components/badges/FeedbackAverageBadge.vue";
import DataGridComponent from "@/components/shared/DataGrid.vue";
import SubheaderComponent from "@/components/structure/Subheader.vue";
import DatePickerComponent from "@/components/forms/Datepicker.vue";
import DateTimePickerComponent from "@/components/forms/Datetimepicker.vue";
import TimePickerComponent from "@/components/forms/Timepicker.vue";
import SingleSelectorComponent from "@/components/forms/SingleSelector.vue";
import ColorPickerComponent from "@/components/forms/Colorpicker.vue";
import PanelComponent from "@/components/shared/Panel.vue";
import HTMLEditorComponent from "@/components/forms/HtmlEditor.vue";
import MetadataFormComponent from "@/components/forms/MetadataForm.vue";
import MetadataPresenterComponent from "@/components/forms/MetadataPresenter.vue";
import NotificationComponent from "@/components/shared/Notification.vue";
import DetailUserBoxComponent from "@/views/users/shared/DetailBox.vue";

Vue.component("DateClock", DateClockComponent);
Vue.component("Breadcrumb", BreadcrumbComponent);
Vue.component("FullLayout", FullLayoutComponent);
Vue.component("LeftMenuLayout", LeftMenuLayoutComponent);
Vue.component("Subheader", SubheaderComponent);
Vue.component("UserBadge", UserBadgeComponent);
Vue.component("FeedbackBadge", FeedbackBadgeComponent);
Vue.component("FeedbackAverageBadge", FeedbackAverageBadgeComponent);
Vue.component("DatePicker", DatePickerComponent);
Vue.component("TimePicker", TimePickerComponent);
Vue.component("DateTimePicker", DateTimePickerComponent);
Vue.component("ColorPicker", ColorPickerComponent);
Vue.component("SingleSelector", SingleSelectorComponent);
Vue.component("Panel", PanelComponent);
Vue.component("DataGrid", DataGridComponent);
Vue.component("HTMLEditor", HTMLEditorComponent);
Vue.component("MetadataForm", MetadataFormComponent);
Vue.component("MetadataPresenter", MetadataPresenterComponent);
Vue.component("Notification", NotificationComponent);
Vue.component("DetailUserBoxComponent", DetailUserBoxComponent);
